import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import ScheduleTaskCard from './ScheduleTaskCard';
import { format } from 'date-fns';

function ScheduleBoardCell({ date, workCenter, schedules, onDeleteSchedule, onSplitSchedule, onExportProcess, onEditNote, rowColor }) {
  const dateKey = format(date, 'yyyy-MM-dd');
  const cellId = `cell-${workCenter._id}-${dateKey}`;

  const { setNodeRef, isOver } = useDroppable({
    id: cellId,
    data: {
      type: 'board-cell',
      workCenterId: workCenter._id,
      workCenterName: workCenter.name,
      date,
      dateKey,
    },
  });

  const totalQty = schedules?.reduce((sum, s) => sum + (s.assigned_quantity || 0), 0) || 0;
  const totalTime = schedules?.reduce((sum, s) => sum + (s.standard_time || 0), 0) || 0;

  const sortableItems = schedules?.map((s) => `board-task-${s._id}`) || [];

  return (
    <div
      ref={setNodeRef}
      className={`
        w-[280px] shrink-0 min-h-[80px] p-1.5 border-r border-b border-gray-200
        transition-colors
        ${isOver ? 'bg-blue-50 ring-inset ring-2 ring-blue-300' : rowColor ? `${rowColor.bg} hover:brightness-[0.97]` : 'bg-white hover:bg-gray-50'}
      `}
    >
      {schedules?.length > 0 && (
        <div className="flex items-center justify-between mb-1 px-0.5">
          <span className="text-[10px] text-gray-400">
            {schedules.length}项 · {totalQty}件
          </span>
          {totalTime > 0 && (
            <span className="text-[10px] text-gray-400">{totalTime}分</span>
          )}
        </div>
      )}
      <SortableContext
        items={sortableItems}
        strategy={verticalListSortingStrategy}
      >
        <div className="space-y-1">
          {schedules?.map((schedule) => (
            <ScheduleTaskCard
              key={schedule._id}
              schedule={schedule}
              onDelete={onDeleteSchedule}
              onSplit={onSplitSchedule}
              onExportProcess={onExportProcess}
              onEditNote={onEditNote}
            />
          ))}
        </div>
      </SortableContext>
    </div>
  );
}

export default ScheduleBoardCell;
